export enum Type {
  RED = 'red',
  BLUE = 'blue',
  CYAN = 'cyan',
  GREEN = 'green',
  PURPLE = 'purple',
  YELLOW = 'yellow'
}

export enum Size {
  SMALL = 'sm',
  LARGE = 'lg'
}

export interface Props {
  children: React.ReactNode,
  type?: Type,
  size?: Size,
  link?: string,
  className?: string,
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  isLoading?: boolean
}
